import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Machinery Equipment',
  items: [
    {
      title: 'Air Compressors/Dryers',
      hasMaker: false,
      hasType: false,
      makers: [
        'Sauer & Sohn',
        'Sperre',
        'Atlas Copco',
        'Yanmar',
        'Hatlapa',
        'Donghwa Pneutec',
        'Nihon Seiki',
        'TMC',
        'Tanabe',
        'Paramina',
        'DUP Compressors',
        'DENO Compressors',
        'ABC Compressors',
        'ADC (American Dryer Corporation)',
        'GEA',
        'Alup Kompressoren',
        'ALMiG',
        'ABAC',
        'Macgregor',
        'Suction Gas',
        'Matsubara',
      ],
      standardServices: [],
      items: [
        {
          title: 'Control Air Compressor',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Major Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Control Air Dryer',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Main Air Compressors',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Major Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Working Air Compressor',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Major Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Auxiliary Engines',
      hasMaker: true,
      hasType: true,
      makers: [
        'Himsen',
        'MAN',
        'Wartsila',
        'Daihatsu',
        'Caterpillar',
        'Doosan',
        'STX',
        'Cummins',
        'Yanmar',
        'MTU',
        'Anglo Belgian Corporation',
        'Anqing',
        'Bergen Diesel Engines',
        'Kawasaki',
        'Zhenjiang',
        'Volvo Penta',
        'Rolls Royce',
        'IHI',
        'ABB',
      ],
      standardServices: [
        {
          title: 'Major Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'Attached Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Crankshaft',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Machining in Situ',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Machining at Shop',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Overhauling/Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Cylinder Heads',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Recondition',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Governor',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Adjustment',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Injectors',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Liners',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Oil Coolers',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Pistons',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Turbocharger',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Major Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Cartridge Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Ballast Water Treatment System',
      hasMaker: true,
      hasType: true,
      makers: [
        'ERMA First',
        'Wartsila',
        'Jowa',
        'Samsung',
        'Techcross',
        'Panasia',
        'NK',
        'Hanla',
        'Alfa Laval',
        'EVAC',
        'Sunrui',
      ],
      standardServices: [
        {
          title: 'Control System Troubleshooting',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Electrodes Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Filter Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'UV Lamps Replacement',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'CPP',
      hasMaker: true,
      hasType: true,
      makers: ['Rolls Royce', 'Berg Propulsion', 'Kawasaki'],
      standardServices: [
        {
          title: 'Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Elevator',
      hasMaker: true,
      hasType: true,
      makers: ['Hitachi', 'Hyundai Elevator', 'OTIS', 'Schindler'],
      standardServices: [
        {
          title: 'Annual Service',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Overhauling/Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Emergency Diesel Generator',
      hasMaker: true,
      hasType: true,
      makers: ['Cummins', 'GPC', 'Mitsui Zosen'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Engine Room Crane',
      hasMaker: true,
      hasType: true,
      makers: ['Sekigahara', 'Futaba', 'Oriental'],
      standardServices: [
        {
          title: 'Load Test',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Engine Room Pumps',
      hasMaker: true,
      hasType: false,
      makers: [
        'Taiko',
        'Naniwa',
        'Alfa Laval',
        'Shinko',
        'KSB',
        'Teikoku',
        'Azcue',
        'IMO',
        'Hyundai',
        'Heishin',
        'Shinshin',
        'Hamworthy',
        'Danfoss',
        'Allweiler',
        'Desmi',
        'AP Pumpen',
        'ABS Pumps',
        'Ebara',
        'A-Ryung',
        'Shin Shin',
      ],
      standardServices: [
        {
          title: 'Overhauling/Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Rotating Machinery Vibration Analysis',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'Aux Boiler Feed Water Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Bilge Transfer Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Central FW Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Ejector Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Fire Bilge GS Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'FO Booster/Circulating Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'FO Supply Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'FO Transfer Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Harbour Cooling SW Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'HT Cooling Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'IG Deck Seal Water Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Jacket Cooling FW Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'LT Cooling Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Main Cooling SW Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'ME LO Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'MGO Transfer Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'LO Transfer Pumps',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Scrubber CSW Pumps',
          hasMaker: true,
          hasType: false,
          makers: ['Taiko'],
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Sewage Pumps',
          hasMaker: true,
          hasType: true,
          makers: ['Taiko'],
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Sludge Pump',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Repair',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Engine Room Ventilation Fans',
      hasMaker: true,
      hasType: false,
      makers: ['Hi Air', 'Ocean Tech', 'Taiyo', 'Nishishiba', 'Hirose'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'FO Booster Module',
      hasMaker: true,
      hasType: true,
      makers: ['Alfa Laval', 'Wartsila'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'FW Generator',
      hasMaker: true,
      hasType: true,
      makers: [
        'Krosys',
        'ENWA',
        'Gefico',
        'Farad',
        'Alfa Laval',
        'Evac',
        'Cathelco',
        'Wartsila',
        'Sondex',
        'Danfoss',
        'Donghwa Entec',
        'Sasakura',
        'Miura',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Heat Exchangers',
      hasMaker: false,
      hasType: false,
      makers: [
        'Alfa Laval',
        'Mytec - Sondex',
        'LHE',
        'Danfoss',
        'Sondex  ',
        'Donghwa Entec',
        'Hisaka',
        'Farad',
        'Sasakura',
        'Tranter',
        'ASA Hydraulik',
        'API Schmidt Bretten',
        'AMI Exchangers',
        'Kelvion Heat Exchangers',
        'Yamashina Seiki',
        'Kajiwara',
        'Showa',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'Auxiliary Boilers Fuel Oil Heaters',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Atmospheric Condenser',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Auxiliary Condenser',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Calorifier',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },

        {
          title: 'Central FW Coolers',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'DO Coolers',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Drain Cooler',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Generator Engine Fuel Oil Heater',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Lubricating Oil Cooler',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Main Engine Fuel Oil Heater',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Main Engine FW Heater',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Main Engine Jacket Cooler',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [
                MatchingType.PARENT_EQUIPMENT,
                MatchingType.STANDARD_SERVICE,
              ],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Purifier Fuel Oil Heater',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'Purifier Lubricating Oil Heaters',
          hasMaker: true,
          hasType: false,
          standardServices: [
            {
              title: 'Overhauling/Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Plates/Gaskets Replacement',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Retubing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Pressure Testing',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Cleaning',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'ICCP',
      hasMaker: true,
      hasType: true,
      makers: ['KC', 'EVAC Cathelco', 'Wilson Walton (Sehong)', 'Hwaseung'],
      standardServices: [
        {
          title: 'Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Underwater Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Incinerator',
      hasMaker: true,
      hasType: true,
      makers: [
        'Hyundai - Atlas',
        'Atlas Incinerators',
        'Miura',
        'Sunflame',
        'Teamtec',
        'Kay Lindegaard Incinerators',
        'Kangrim',
        'Volcano',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Main Engine',
      hasMaker: true,
      hasType: true,
      makers: [
        'MAN',
        'Wartsila',
        'Mitsui',
        'Mitsubishi',
        'MAK',
        'Rolls Royce',
        'Hyundai',
        'Hitachi',
        'Kobe Diesel',
        'STX',
        'Hudong',
        'Brodosplit',
        'Doosan',
        'Akasaka',
        'Kawasaki',
        'Sulzer',
      ],
      standardServices: [
        {
          title: 'Major Overhaul',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'Aircooler',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Auxiliary Blowers',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Bearings',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Replacement/Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Camshaft/Crankshaft',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Machining',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Cylinder Heads',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Recondition',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Exhaust Valves',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Replacement/Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Recondition',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'FIVA/Control System',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Fuel Pumps',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Overhauling/Measurement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Recondition',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Gas Admission Valve',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Governor',
          hasMaker: true,
          hasType: true,
          makers: ['Woodward', 'Governors America Corp', 'Nabco'],
          standardServices: [
            {
              title: 'Adjustment',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Injectors',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },

        {
          title: 'Liners',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Honing',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'LDM measurement from Scavenge Space',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Lubricator System',
          hasMaker: true,
          hasType: true,
          makers: ['Alpha Lubricator', 'Hans Jensen'],
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Retrofit',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Manoeuvring System',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Oil Mist Detector',
          hasMaker: true,
          hasType: true,
          makers: ['Daihatsu', 'Schaller'],
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Pistons',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Replacement/Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Recondition',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Stuffing Box',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Replacement/Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Turbocharger',
          hasMaker: true,
          hasType: true,
          makers: [
            'ABB',
            'MAN',
            'Hyundai',
            'MET',
            'IHI',
            'Kawasaki',
            'Mitsubishi',
          ],
          standardServices: [
            {
              title: 'Blades Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Balancing',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Nozzle Ring Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'MGPS',
      hasMaker: true,
      hasType: true,
      makers: ['EVAC', 'Daiki', 'Saake', 'Nippon', 'HWASEUNG'],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'ODME',
      hasMaker: true,
      hasType: true,
      makers: ['Brannstrom', 'VAF', 'Scanjet', 'Jowa', 'Seil'],
      standardServices: [
        {
          title: 'Annual Check',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Calibration',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'OWS',
      hasMaker: true,
      hasType: true,
      makers: [
        'Georim',
        'Hyundai - Detegasa',
        'Deckma',
        'Taiko',
        'Rivertrace',
        'Heishin',
        'Sasakura',
        'Jowa',
        'SKF Marine',
        'Aalandia',
        'Filtration Group - Mahle',
        'Brannstrom',
        'HSN-Kikai',
        'Kogyo',
      ],
      standardServices: [
        {
          title: 'Annual Check',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: '5 Year Calibration',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'OWS Oil Content Meter',
          hasMaker: true,
          hasType: true,
          makers: [
            'Fellow Kogyo',
            'Rivertrace',
            'Deckma',
            'VAF',
            'Georim',
            'Jowa',
            'Brannstrom',
            'Taiko',
            'Jinbo Marine',
          ],
          standardServices: [
            {
              title: 'Annual Calibration',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: '5 Year Calibration',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Purifiers',
      hasMaker: true,
      hasType: true,
      makers: ['Samgong', 'GEA - Westfalia', 'Alfa Laval', 'Mitsubishi'],
      standardServices: [
        {
          title: 'Other',
          matching: [],
        },
      ],
      items: [
        {
          title: 'DO Purifiers',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Control System Overhaul',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Troubleshooting/Overhauling',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'FO Purifiers',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Control System Overhaul',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Troubleshooting/Overhauling',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
        {
          title: 'LO Purifiers',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Control System Overhaul',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Troubleshooting/Overhauling',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.PARENT_EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Shaft Generator',
      hasMaker: false,
      hasType: false,
      makers: [],
      standardServices: [
        {
          title: 'Alignment',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Shafting',
      hasMaker: false,
      hasType: false,
      standardServices: [],
      items: [
        {
          title: 'Gearbox',
          hasMaker: false,
          hasType: false,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Intermediate Bearing',
          hasMaker: false,
          hasType: false,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Intermediate Shaft',
          hasMaker: false,
          hasType: false,
          standardServices: [
            {
              title: 'Bearing Repair/Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Propeller',
          hasMaker: true,
          hasType: false,
          makers: ['Nakashima', 'Kobe Steel', 'HHI'],
          standardServices: [
            {
              title: 'Seals Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Stern Tube',
          hasMaker: true,
          hasType: true,
          makers: [
            'Wartsila',
            'SKF Simplex',
            'Kemel',
            'Blohm + Voss',
            'Kobelco',
          ],
          standardServices: [
            {
              title: 'Bush Repair/Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Stern Tube Seals Replacement',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Stern Tube Seals Bonding',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Tail Shaft',
          hasMaker: false,
          hasType: false,
          standardServices: [
            {
              title: 'Alignment',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Chock Fast Repair',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Scrubber',
      hasMaker: true,
      hasType: true,
      makers: ['Ecospray', 'Saacke', 'Panasia', 'Wartsila'],
      standardServices: [
        {
          title: 'Catalyst Replacement',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'NOX/SOX sensor Calibration',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Overhauling/Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Sewage Treatment Plant',
      hasMaker: true,
      hasType: true,
      makers: [
        'Jonghap',
        'Ilseung',
        'Jowa',
        'Sasakura',
        'Westfalia',
        'EVAC',
        'Wartsila',
        'Goko Seisakusho',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Steam Generating Plant',
      hasMaker: false,
      hasType: false,
      makers: [
        'Kangrim',
        'Aalborg - Alfa Laval',
        'Saacke',
        'Mitsubishi',
        'Osaka',
        'Kawasaki',
        'Teamtec',
        'Hamworthy',
        'Tortoise',
        'Miura',
      ],
      standardServices: [],
      items: [
        {
          title: 'Auxiliary Boiler',
          hasMaker: true,
          hasType: true,
          makers: [
            'Kangrim',
            'Aalborg - Alfa Laval',
            'Saacke',
            'Mitsubishi',
            'Osaka',
            'Kawasaki',
            'Teamtec',
            'Hamworthy',
            'Tortoise',
            'Miura',
          ],
          standardServices: [
            {
              title: 'Burner Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Automation Adjustment/Service',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Re-tubing',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Safety Valves service',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Health Test',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Composite Boiler',
          hasMaker: true,
          hasType: true,
          makers: [
            'Kangrim',
            'Aalborg - Alfa Laval',
            'Saacke',
            'Mitsubishi',
            'Osaka',
            'Kawasaki',
            'Teamtec',
            'Hamworthy',
            'Tortoise',
            'Miura',
          ],
          standardServices: [
            {
              title: 'Forced Draft Fan Balancing',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Burner Overhauling',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Automation Adjustment/Service',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Re-tubing',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Safety Valves service',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Health Test',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Economizer',
          hasMaker: true,
          hasType: true,
          makers: [
            'Kangrim',
            'Aalborg - Alfa Laval',
            'Saacke',
            'Mitsubishi',
            'Osaka',
            'Kawasaki',
            'Teamtec',
            'Hamworthy',
            'Tortoise',
            'Miura',
          ],
          standardServices: [
            {
              title: 'Re-tubing',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Safety Valves service',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'Forced Draft Fan',
          hasMaker: true,
          hasType: true,
          makers: [],
          standardServices: [
            {
              title: 'Balancing',
              matching: [MatchingType.EQUIPMENT],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Steering Gear',
      hasMaker: true,
      hasType: true,
      makers: ['Rolls Royce', 'Macgregor', 'Mitsubishi', 'Kawasaki', 'Hi Air'],
      standardServices: [
        {
          title: 'Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Thrusters',
      hasMaker: true,
      hasType: true,
      makers: [
        'Kongsberg (Rolls Royce)',
        'Kawasaki',
        'Wartsila',
        'Berg Propulsion',
        'Schottel',
        'ABB',
        'Brunvoll',
        'ABS Hydromarine',
        'KTE Nakashima',
        'Kobelt',
      ],
      standardServices: [
        {
          title: 'Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Underwater Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
